import React, { useState, useEffect } from 'react';
import { useSetStoreValue, useStore } from 'react-context-hook'
import { ImageBackground, View, ScrollView } from 'react-native'
import { Layouts } from '../../utils'
import Styles from '../../Styles'
import * as Logger from '../../utils/Logger/index'
import { Container, H1,  Header,  Title,  Button,  Card,  CardItem,  Icon,  Text,  Left,  Right,  Body, List, ListItem, Thumbnail, Content, Picker, Form, Item, Label, Tab, Tabs, TabHeading } from 'native-base';
import Slider from '@react-native-community/slider'
import { colorPalette } from '../../utils/Styles';
import * as DashboardData from '../../utils/TestData/DashboardData';


export default function SearchScreenMain({ navigation }) {
    
    //adds the menu buttons to the header
    Layouts.StackNavigationHeader({navigation});

    //default store items for use in the screen
    const [platform] = useStore('platform')
    const [displayDesktop] = useStore('displayDesktop')
    const [enableConsoleLogging] = useStore('enableConsoleLogging')
    const [enableSentryLogging] = useStore('enableSentryLogging')
    const [enableAlertLogging] = useStore('enableAlertLogging')

    //screen specific code
    const [showSearchOptions, setShowSearchOptions] = useState(false)

    //basic search options 
    const [selectedGender, setSelectedGender] = useState('key0')
    const [ageLow, setAgeLow] = useState(25)
    const [ageHigh, setAgeHigh] = useState(40)
    const [heightLow, setHeightLow] = useState(50)
    const [heightHigh, setHeightHigh] = useState(115)
    const [distanceFromMe, setDistanceFromMe] = useState(50)
    const [maritalStatus, setMaritalStatus] = useState('key0')

    // advanced search options 
    const [bodyType, setBodyType] = useState('key0')
    const [eyeColor, setEyeColor] = useState('key0')
    const [hairColor, setHairColor] = useState('key0')
    const [ethnicity, setEthnicity] = useState('key0')
    const [race, setRace] = useState('key0')
    const [religion, setReligion] = useState('key0')
    const [branchOfService, setBranchOfService] = useState('key0')
    const [politicalAffiliation, setPoliticalAffiliation] = useState('key0')
    const [employment, setEmployment] = useState('key0')
    const [educationLevel, setEducationLevel] = useState('key0')
    const [incomeLevel, setIncomeLevel] = useState('key0')


    const onPress = () => {
        alert('clicked')
      }

    const onPressDisplaySearchOptions = () => {
        setShowSearchOptions(true)
    }
    
    const onPressCloseSearchOptions = () => {
        setShowSearchOptions(false)
    }

    const onProfileCardImagePress = () => {
        alert('profile card')
    }

    function BasicSearchOptions ({}) {
    
        return(
            <ScrollView style={{flex:1}}
                contentContainerStyle={{flex:1, justifyContent:'center', alignContent:'center'}}>
                <View
                    style={displayDesktop ? Styles.Typography.searchOptions.optionsContainerWithinTab : Styles.Typography.searchOptions.optionsContainerWithinTabMobile}
                >

                    <View style={Styles.Typography.searchOptions.individualOptionsContainerMobile}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Gender
                        </Text>
                        <Picker 
                            style={Styles.Typography.searchOptions.optionsStyle}
                            mode='dropdown'
                            iosIcon={<Icon name="arrow-down" />}
                            selectedValue={selectedGender}
                            onValueChange={(itemValue, itemIndex) => {setSelectedGender(itemValue)}}
                        >
                            <Picker.Item label='Any' value='key0' />
                            <Picker.Item label='Male' value='key1' />
                            <Picker.Item label='Female' value='key2' />
                        </Picker>
                    </View>

                    <View style={Styles.Typography.searchOptions.individualOptionsContainerMobile}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Marital Status:
                        </Text>
                        <Picker 
                            style={{width: 300, height: 30}}
                            mode='dropdown'
                            iosIcon={<Icon name="arrow-down" />}
                            selectedValue={maritalStatus}
                            onValueChange={(itemValue, itemIndex) => {setMaritalStatus(itemValue)}}
                        >
                            <Picker.Item label='Single' value='key0' />
                            <Picker.Item label='Married' value='key1' />
                            <Picker.Item label='Divorced' value='key2' />
                        </Picker>
                    </View>
    
                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Age Low: {ageLow}
                        </Text>
                        <Slider
                            style={Styles.Typography.searchOptions.optionsStyle}
                            minimumValue={18}
                            maximumValue={99}
                            minimumTrackTintColor={Styles.Colors.colorPalette.Dark}
                            maximumTrackTintColor={Styles.Colors.colorPalette.mainColor}
                            thumbTintColor={Styles.Colors.colorPalette.mainColor}
                            value={ageLow}
                            step={1}
                            onValueChange={(value) => {setAgeLow(value)}}
                        />
                    </View>
    
                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Age High: {ageHigh}
                        </Text>
                        <Slider
                            style={Styles.Typography.searchOptions.optionsStyle}
                            minimumValue={ageLow}
                            maximumValue={99}
                            minimumTrackTintColor={Styles.Colors.colorPalette.Dark}
                            maximumTrackTintColor={Styles.Colors.colorPalette.mainColor}
                            thumbTintColor={Styles.Colors.colorPalette.mainColor}
                            value={ageHigh}
                            step={1}
                            onValueChange={(value) => {setAgeHigh(value)}}
                        />
                    </View>
    
                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}> 
                            Height Low: {heightLow}
                        </Text>
                        <Slider
                            style={Styles.Typography.searchOptions.optionsStyle}
                            minimumValue={20}
                            maximumValue={99}
                            minimumTrackTintColor={Styles.Colors.colorPalette.Dark}
                            maximumTrackTintColor={Styles.Colors.colorPalette.mainColor}
                            thumbTintColor={Styles.Colors.colorPalette.mainColor}
                            value={heightLow}
                            step={1}
                            onValueChange={(value) => {setHeightLow(value)}}
                        />
                    </View>
    
                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Height High: {heightHigh}
                        </Text>
                        <Slider
                            style={Styles.Typography.searchOptions.optionsStyle}
                            minimumValue={heightLow}
                            maximumValue={120}
                            minimumTrackTintColor={Styles.Colors.colorPalette.Dark}
                            maximumTrackTintColor={Styles.Colors.colorPalette.mainColor}
                            thumbTintColor={Styles.Colors.colorPalette.mainColor}
                            value={heightHigh}
                            step={1}
                            onValueChange={(value) => {setHeightHigh(value)}}
                        />
                    </View>
    
                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Distance From Me: {distanceFromMe}
                        </Text>
                        <Slider
                            style={Styles.Typography.searchOptions.optionsStyle}
                            minimumValue={10}
                            maximumValue={250}
                            minimumTrackTintColor={Styles.Colors.colorPalette.Dark}
                            maximumTrackTintColor={Styles.Colors.colorPalette.mainColor}
                            thumbTintColor={Styles.Colors.colorPalette.mainColor}
                            value={distanceFromMe}
                            step={20}
                            onValueChange={(value) => {setDistanceFromMe(value)}}
                        />
                    </View>
    
                </View>
            </ScrollView>
    
        )
    }

    function AdvancedSearchOptions ({}) {

        return(
            <ScrollView style={{flex:1}}
                contentContainerStyle={{flex:1}}>
                <View
                    style={Styles.Typography.searchOptions.optionsContainerWithinTab}
                >

                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Body Type
                        </Text>
                        <Picker 
                            style={Styles.Typography.searchOptions.optionsStyle}
                            mode='dropdown'
                            iosIcon={<Icon name="arrow-down" />}
                            selectedValue={bodyType}
                            onValueChange={(itemValue, itemIndex) => {setBodyType(itemValue)}}
                        >
                            <Picker.Item label='Any' value='key0' />
                            <Picker.Item label='Athletic' value='key1' />
                            <Picker.Item label='Curvy' value='key2' />
                        </Picker>
                    </View>

                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Eye Color
                        </Text>
                        <Picker 
                            style={Styles.Typography.searchOptions.optionsStyle}
                            mode='dropdown'
                            iosIcon={<Icon name="arrow-down" />}
                            selectedValue={eyeColor}
                            onValueChange={(itemValue, itemIndex) => {setEyeColor(itemValue)}}
                        >
                            <Picker.Item label='Any' value='key0' />
                            <Picker.Item label='Blue' value='key1' />
                            <Picker.Item label='Hazel' value='key2' />
                        </Picker>
                    </View>

                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Hair Color
                        </Text>
                        <Picker 
                            style={Styles.Typography.searchOptions.optionsStyle}
                            mode='dropdown'
                            iosIcon={<Icon name="arrow-down" />}
                            selectedValue={hairColor}
                            onValueChange={(itemValue, itemIndex) => {setHairColor(itemValue)}}
                        >
                            <Picker.Item label='Any' value='key0' />
                            <Picker.Item label='Black' value='key1' />
                            <Picker.Item label='Blond' value='key2' />
                        </Picker>
                    </View>
 
                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Ethnicity
                        </Text>
                        <Picker 
                            style={Styles.Typography.searchOptions.optionsStyle}
                            mode='dropdown'
                            iosIcon={<Icon name="arrow-down" />}
                            selectedValue={ethnicity}
                            onValueChange={(itemValue, itemIndex) => {setEthnicity(itemValue)}}
                        >
                            <Picker.Item label='Any' value='key0' />
                            <Picker.Item label='Hispanic or Latino' value='key1' />
                            <Picker.Item label='Not Hispanic or Latino' value='key2' />
                        </Picker>
                    </View>

                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Race
                        </Text>
                        <Picker 
                            style={Styles.Typography.searchOptions.optionsStyle}
                            mode='dropdown'
                            iosIcon={<Icon name="arrow-down" />}
                            selectedValue={race}
                            onValueChange={(itemValue, itemIndex) => {setRace(itemValue)}}
                        >
                            <Picker.Item label='Any' value='key0' />
                            <Picker.Item label='American Indian or Alaska Native' value='key1' />
                            <Picker.Item label='Asian' value='key2' />
                        </Picker>
                    </View>

                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Religion
                        </Text>
                        <Picker 
                            style={Styles.Typography.searchOptions.optionsStyle}
                            mode='dropdown'
                            iosIcon={<Icon name="arrow-down" />}
                            selectedValue={religion}
                            onValueChange={(itemValue, itemIndex) => {setReligion(itemValue)}}
                        >
                            <Picker.Item label='Any' value='key0' />
                            <Picker.Item label='Christian' value='key1' />
                            <Picker.Item label='Hindu' value='key2' />
                        </Picker>
                    </View>

                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Branch of Service
                        </Text>
                        <Picker 
                            style={Styles.Typography.searchOptions.optionsStyle}
                            mode='dropdown'
                            iosIcon={<Icon name="arrow-down" />}
                            selectedValue={branchOfService}
                            onValueChange={(itemValue, itemIndex) => {setBranchOfService(itemValue)}}
                        >
                            <Picker.Item label='Any' value='key0' />
                            <Picker.Item label='Air Force' value='key1' />
                            <Picker.Item label='Army' value='key2' />
                        </Picker>
                    </View>

                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Political Affiliation
                        </Text>
                        <Picker 
                            style={Styles.Typography.searchOptions.optionsStyle}
                            mode='dropdown'
                            iosIcon={<Icon name="arrow-down" />}
                            selectedValue={politicalAffiliation}
                            onValueChange={(itemValue, itemIndex) => {setPoliticalAffiliation(itemValue)}}
                        >
                            <Picker.Item label='Any' value='key0' />
                            <Picker.Item label='Democratic' value='key1' />
                            <Picker.Item label='Republican' value='key2' />
                        </Picker>
                    </View>

                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Employment
                        </Text>
                        <Picker 
                            style={Styles.Typography.searchOptions.optionsStyle}
                            mode='dropdown'
                            iosIcon={<Icon name="arrow-down" />}
                            selectedValue={employment}
                            onValueChange={(itemValue, itemIndex) => {setEmployment(itemValue)}}
                        >
                            <Picker.Item label='Any' value='key0' />
                            <Picker.Item label='Full-Time' value='key1' />
                            <Picker.Item label='Part-Time' value='key2' />
                        </Picker>
                    </View>

                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Education Level
                        </Text>
                        <Picker 
                            style={Styles.Typography.searchOptions.optionsStyle}
                            mode='dropdown'
                            iosIcon={<Icon name="arrow-down" />}
                            selectedValue={educationLevel}
                            onValueChange={(itemValue, itemIndex) => {setEducationLevel(itemValue)}}
                        >
                            <Picker.Item label='Any' value='key0' />
                            <Picker.Item label='Bachelor' value='key1' />
                            <Picker.Item label='Associates' value='key2' />
                        </Picker>
                    </View>

                    <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                        <Text style={Styles.Typography.searchOptions.optionsLabel}>
                            Income Level
                        </Text>
                        <Picker 
                            style={Styles.Typography.searchOptions.optionsStyle}
                            mode='dropdown'
                            iosIcon={<Icon name="arrow-down" />}
                            selectedValue={incomeLevel}
                            onValueChange={(itemValue, itemIndex) => {setIncomeLevel(itemValue)}}
                        >
                            <Picker.Item label='Any' value='key0' />
                            <Picker.Item label='$0 - $50K' value='key1' />
                            <Picker.Item label='$50K - $75K' value='key2' />
                        </Picker>
                    </View>
    
                </View>
            </ScrollView>
    
        )
    }

    return (

        <ImageBackground source={global.BackgroundImage} style={displayDesktop ? Styles.Typography.generalAppContainer.desktop : Styles.Typography.generalAppContainer.mobile}>
            
            <View style={{}}>
                <Styles.Buttons.PrimaryButton text='Edit Search Options' onPress={onPressDisplaySearchOptions} />
            </View>
            
            <View style={displayDesktop ? Styles.Typography.searchScreenContainer.desktop : Styles.Typography.searchScreenContainer.mobile}>
        
                {/* <ScrollView 
                    style={{  }}
                    contentContainerStyle={{ flexGrow:1, flexDirection:'row', justifyContent:'flex-start' }}
                    //horizontal
                >
                    {DashboardData.matchData.map(card =>
                        <Styles.Components.ProfileCard 
                            fullName={card.fullName}
                            image={card.image}
                            percentageMatch={card.percentageMatch}
                            gender={card.gender}
                            age={card.age}
                            favored={card.favored}
                        />
                    )}
                </ScrollView> */}
                
                <ScrollView
                    contentContainerStyle={Styles.Typography.searchScreenContainer.mobileScroll}
                >
                    {DashboardData.matchData.map(card =>
                        <Styles.Components.ProfileCardSlim 
                            displayDesktop={displayDesktop}
                            onPress={onProfileCardImagePress}
                            fullName={card.fullName}
                            image={card.image}
                            percentageMatch={card.percentageMatch}
                            gender={card.gender}
                            age={card.age}
                            favored={card.favored}
                        />
                    )}
                </ScrollView>

                {displayDesktop ?                 
                    <Styles.ModalWeb showModal={showSearchOptions}>
                        <View style={Styles.Typography.searchOptions.modalWebContainer}>
                            <Tabs>
                            {/* <Tab heading={ <TabHeading><Icon style='AntDesign' name='camera' /><Text>Camera</Text></TabHeading>}> */}
                                <Tab 
                                    heading='Basic'
                                    tabStyle={Styles.Typography.searchOptions.tabStyle}
                                    textStyle={Styles.Typography.searchOptions.tabTextStyle}
                                    activeTabStyle={Styles.Typography.searchOptions.activeTabStyle}
                                    activeTextStyle={Styles.Typography.searchOptions.activeTabTextStyle}
                                >
                                    <BasicSearchOptions />
                                </Tab>
                                <Tab 
                                    heading='Advanced'
                                    tabStyle={Styles.Typography.searchOptions.tabStyle}
                                    textStyle={Styles.Typography.searchOptions.tabTextStyle}
                                    activeTabStyle={Styles.Typography.searchOptions.activeTabStyle}
                                    activeTextStyle={Styles.Typography.searchOptions.activeTabTextStyle}
                                >
                                    <AdvancedSearchOptions />
                                </Tab>
                            </Tabs>
                            <Styles.Buttons.PrimaryButton text='Search' onPress={onPressCloseSearchOptions} />
                            <Styles.Buttons.DarkButton text='Cancel' onPress={onPressCloseSearchOptions} />
                        </View>
                    </Styles.ModalWeb>
                :
                    <Styles.ModalMobile showModal={showSearchOptions}>
                        <View style={{flex:1, backgroundColor:Styles.Colors.colorPalette.White}}>
                        <Tabs>
                            {/* <Tab heading={ <TabHeading><Icon style='AntDesign' name='camera' /><Text>Camera</Text></TabHeading>}> */}
                                <Tab 
                                    heading='Basic'
                                    tabStyle={Styles.Typography.searchOptions.tabStyle}
                                    textStyle={Styles.Typography.searchOptions.tabTextStyle}
                                    activeTabStyle={Styles.Typography.searchOptions.activeTabStyle}
                                    activeTextStyle={Styles.Typography.searchOptions.activeTabTextStyle}
                                >
                                    <ScrollView style={{flex:1}}
                                        contentContainerStyle={{flex:1, justifyContent:'center', alignContent:'center'}}>
                                        <View
                                            style={displayDesktop ? Styles.Typography.searchOptions.optionsContainerWithinTab : Styles.Typography.searchOptions.optionsContainerWithinTabMobile}
                                        >

                                            <View style={Styles.Typography.searchOptions.individualOptionsContainerMobile}>
                                                <Text style={Styles.Typography.searchOptions.optionsLabel}>
                                                    Gender
                                                </Text>
                                                <Picker 
                                                    style={Styles.Typography.searchOptions.optionsStyle}
                                                    mode='dropdown'
                                                    iosIcon={<Icon name="arrow-down" />}
                                                    selectedValue={selectedGender}
                                                    onValueChange={(itemValue, itemIndex) => {setSelectedGender(itemValue)}}
                                                >
                                                    <Picker.Item label='Any' value='key0' />
                                                    <Picker.Item label='Male' value='key1' />
                                                    <Picker.Item label='Female' value='key2' />
                                                </Picker>
                                            </View>

                                            <View style={Styles.Typography.searchOptions.individualOptionsContainerMobile}>
                                                <Text style={Styles.Typography.searchOptions.optionsLabel}>
                                                    Marital Status:
                                                </Text>
                                                <Picker 
                                                    style={{width: 300, height: 30}}
                                                    mode='dropdown'
                                                    iosIcon={<Icon name="arrow-down" />}
                                                    selectedValue={maritalStatus}
                                                    onValueChange={(itemValue, itemIndex) => {setMaritalStatus(itemValue)}}
                                                >
                                                    <Picker.Item label='Single' value='key0' />
                                                    <Picker.Item label='Married' value='key1' />
                                                    <Picker.Item label='Divorced' value='key2' />
                                                </Picker>
                                            </View>
                            
                                            <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                                                <Text style={Styles.Typography.searchOptions.optionsLabel}>
                                                    Age Low: {ageLow}
                                                </Text>
                                                <Slider
                                                    style={Styles.Typography.searchOptions.optionsStyle}
                                                    minimumValue={18}
                                                    maximumValue={99}
                                                    minimumTrackTintColor={Styles.Colors.colorPalette.Dark}
                                                    maximumTrackTintColor={Styles.Colors.colorPalette.mainColor}
                                                    thumbTintColor={Styles.Colors.colorPalette.mainColor}
                                                    value={ageLow}
                                                    step={1}
                                                    onValueChange={(value) => {setAgeLow(value)}}
                                                />
                                            </View>
                            
                                            <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                                                <Text style={Styles.Typography.searchOptions.optionsLabel}>
                                                    Age High: {ageHigh}
                                                </Text>
                                                <Slider
                                                    style={Styles.Typography.searchOptions.optionsStyle}
                                                    minimumValue={18}
                                                    maximumValue={99}
                                                    minimumTrackTintColor={Styles.Colors.colorPalette.Dark}
                                                    maximumTrackTintColor={Styles.Colors.colorPalette.mainColor}
                                                    thumbTintColor={Styles.Colors.colorPalette.mainColor}
                                                    value={ageHigh}
                                                    step={1}
                                                    onValueChange={(value) => {setAgeHigh(value)}}
                                                />
                                            </View>
                            
                                            <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                                                <Text style={Styles.Typography.searchOptions.optionsLabel}> 
                                                    Height Low: {heightLow}
                                                </Text>
                                                <Slider
                                                    style={Styles.Typography.searchOptions.optionsStyle}
                                                    minimumValue={20}
                                                    maximumValue={99}
                                                    minimumTrackTintColor={Styles.Colors.colorPalette.Dark}
                                                    maximumTrackTintColor={Styles.Colors.colorPalette.mainColor}
                                                    thumbTintColor={Styles.Colors.colorPalette.mainColor}
                                                    value={heightLow}
                                                    step={1}
                                                    onValueChange={(value) => {setHeightLow(value)}}
                                                />
                                            </View>
                            
                                            <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                                                <Text style={Styles.Typography.searchOptions.optionsLabel}>
                                                    Height High: {heightHigh}
                                                </Text>
                                                <Slider
                                                    style={Styles.Typography.searchOptions.optionsStyle}
                                                    minimumValue={heightLow}
                                                    maximumValue={120}
                                                    minimumTrackTintColor={Styles.Colors.colorPalette.Dark}
                                                    maximumTrackTintColor={Styles.Colors.colorPalette.mainColor}
                                                    thumbTintColor={Styles.Colors.colorPalette.mainColor}
                                                    value={heightHigh}
                                                    step={1}
                                                    onValueChange={(value) => {setHeightHigh(value)}}
                                                />
                                            </View>
                            
                                            <View style={Styles.Typography.searchOptions.individualOptionsContainer}>
                                                <Text style={Styles.Typography.searchOptions.optionsLabel}>
                                                    Distance From Me: {distanceFromMe}
                                                </Text>
                                                <Slider
                                                    style={Styles.Typography.searchOptions.optionsStyle}
                                                    minimumValue={10}
                                                    maximumValue={250}
                                                    minimumTrackTintColor={Styles.Colors.colorPalette.Dark}
                                                    maximumTrackTintColor={Styles.Colors.colorPalette.mainColor}
                                                    thumbTintColor={Styles.Colors.colorPalette.mainColor}
                                                    value={distanceFromMe}
                                                    step={20}
                                                    onValueChange={(value) => {setDistanceFromMe(value)}}
                                                />
                                            </View>
                            
                                        </View>
                                    </ScrollView>
                                </Tab>
                                <Tab 
                                    heading='Advanced'
                                    tabStyle={Styles.Typography.searchOptions.tabStyle}
                                    textStyle={Styles.Typography.searchOptions.tabTextStyle}
                                    activeTabStyle={Styles.Typography.searchOptions.activeTabStyle}
                                    activeTextStyle={Styles.Typography.searchOptions.activeTabTextStyle}
                                >
                                    <AdvancedSearchOptions />
                                </Tab>
                            </Tabs>
                            <Styles.Buttons.PrimaryButton text='Search' onPress={onPressCloseSearchOptions} />
                            <Styles.Buttons.DarkButton text='Cancel' onPress={onPressCloseSearchOptions} />
                        </View>
                    </Styles.ModalMobile>
                }

            </View>
        </ImageBackground>

    );
}


